export const environment = {
  production: false,
   //apiUrl: 'http://sales-treasure-production.up.railway.app:8080'
    // apiUrl: 'https://georgann-unmenstruating-pablo.ngrok-free.dev'
    // apiUrl: 'https://sprinkled-severity-upon.ngrok-free.dev'
    //  apiUrl: 'https://candle-posting-yin.ngrok-free.dev'
     apiUrl: 'http://13.140.183.81:8080'
  };
